/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {Injectable} from "@angular/core";
import {MissingTranslationHandler, MissingTranslationHandlerParams, TranslateParser} from "@ngx-translate/core";

@Injectable()
export class TranslateLocaleMissingHandler extends MissingTranslationHandler {

    constructor(public parser: TranslateParser) {
        super();
    }

    handle(params: MissingTranslationHandlerParams): string {
        return params.interpolateParams ? this.parser.interpolate(params.key, params.interpolateParams) : params.key ;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/TranslateLocaleMissingHandler.ts